var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHospitalinfoLadydoctor = function SvgHospitalinfoLadydoctor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M20.5 19.18s.54-.4.54-1.85-.54-4.82-.54-4.56v-.57h-9.13l.04.61s-.58 3.12-.58 4.55.54 1.82.54 1.82z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M21.62 11.721c.158-.74-.201-1.443-.801-1.57s-1.213.37-1.37 1.11.202 1.443.802 1.57 1.213-.37 1.37-1.11M11.755 12.83c.6-.127.959-.83.802-1.57s-.77-1.238-1.37-1.11-.959.83-.802 1.57.77 1.237 1.37 1.11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M20 11.81s.65-1.37.41-2.96C20.18 7.27 18.82 5 16 5s-4.18 2.27-4.42 3.86.27 2.96.27 2.96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M15.93 5.78c-2.25 0-4.07 1.82-4.07 4.07v1.96c0 .86.18 1.72.55 2.5.83 1.77 2.19 2.37 3.53 2.37s2.7-.59 3.53-2.37c.37-.78.55-1.64.55-2.5V9.85a4.097 4.097 0 0 0-4.09-4.07"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M11.57 10.24c-.07-.49-.09-.96-.03-1.36C11.77 7.29 13.18 5 16 5s4.18 2.27 4.42 3.86c.06.41.05.91.01 1.42l-.43.4c-3.61-1.6-6.09-3.48-6.09-3.48s-.46 2.45-2.06 3.34z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M18 15.17h-4v3h4zM26.07 27h-20v-3.83c0-2.76 2.24-5 5-5h10c2.76 0 5 2.24 5 5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6726",
    d: "M23.07 22.25h-1.25V21h-1.5v1.25h-1.25v1.5h1.25V25h1.5v-1.25h1.25zM16 22.1 14 17l-1.99 3h2zM16 22.1l2-5.1 1.99 3h-2z"
  })));
};
export default SvgHospitalinfoLadydoctor;